<template>
  <div class="plain-layout">
    <HeaderComponent />
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import HeaderComponent from './Header.vue'

export default defineComponent({
  name: 'PlainLayout',
  components: {
    HeaderComponent
  }
})
</script>

<style lang="scss" scoped>

.plain-layout {
  background-color: rgba(0, 0, 0, 0.04);
}
</style>
